// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import {
  type CompetitorInfo,
  type CompetitorInfoWireFormat,
  NewCompetitorInfo,
} from '../CompetitorInfo/CompetitorInfo';
import {
  NewQuoteCompetitorProduct,
  type QuoteCompetitorProduct,
  type QuoteCompetitorProductWireFormat,
} from '../QuoteCompetitorProduct/QuoteCompetitorProduct';
import {
  NewQuoteLossReason,
  QuoteLossReason,
  type QuoteLossReasonWireFormat,
} from '../QuoteLossReason/QuoteLossReason';

export class QuoteCompetitor {
  readonly id: string;
  readonly products: QuoteCompetitorProduct[];
  readonly competitor: CompetitorInfo | null;
  readonly lossReason: QuoteLossReason;
  readonly lossReasonNotes: string | null;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.products = (data.products ?? []).map((products: any) =>
      NewQuoteCompetitorProduct(products),
    );
    this.competitor =
      // eslint-disable-next-line no-nested-ternary
      (data.competitor ?? null) === null ? null : NewCompetitorInfo(data.competitor);
    this.lossReason = NewQuoteLossReason(data.lossReason);
    this.lossReasonNotes = data.lossReasonNotes === undefined ? null : data.lossReasonNotes;
  }

  static zero(): QuoteCompetitor {
    const zeroValues: ExcludeMethodsDeep<QuoteCompetitor> = {
      id: NIL_UUID,
      products: [],
      competitor: null,
      lossReason: QuoteLossReason.zero(),
      lossReasonNotes: null,
    };
    return new QuoteCompetitor(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type QuoteCompetitorWireFormat = {
  id: string;
  products: QuoteCompetitorProductWireFormat[];
  competitor: CompetitorInfoWireFormat | null;
  lossReason: QuoteLossReasonWireFormat;
  lossReasonNotes: string | null;
};

type NewQuoteCompetitorProps = PartialDeep<QuoteCompetitor, { recurseIntoArrays: true }>;
export const NewQuoteCompetitor: (props: NewQuoteCompetitorProps) => QuoteCompetitor = (props) =>
  new QuoteCompetitor(props);

type NewQuoteCompetitorFromWireFormatProps = PartialDeep<
  QuoteCompetitorWireFormat,
  { recurseIntoArrays: true }
>;
export const NewQuoteCompetitorFromWireFormat: (
  props: NewQuoteCompetitorFromWireFormatProps,
) => QuoteCompetitor = (props) => new QuoteCompetitor(props);
